module.exports = __webpack_public_path__ + "img/vaga1.414ebb93.jpg";